import { render, staticRenderFns } from "./VisibilityScopesPicker.vue?vue&type=template&id=180790d0"
import script from "./VisibilityScopesPicker.vue?vue&type=script&lang=js"
export * from "./VisibilityScopesPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports